require('../../modules/es7.regexp.escape');
module.exports = require('../../modules/$.core').RegExp.escape;


//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/fn/regexp/escape.js
// module id = 303
// module chunks = 0